@import ../../styles/helpers

.gameContainer
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    margin-bottom: 50px
    overflow: hidden
    border-radius: $border_radius_big
    position: relative
    button
        position: absolute
        bottom: calc( $external_margin * 2 )
        left: calc($external_margin * 2)
    img
        width: 100%
        min-height: 100%
        aspect-ratio: auto
        +m
            width: auto
            height: 100%
    +m
        aspect-ratio: 1.5/1
        position: relative
    iframe
        width: 100%
        height: 600px
        border-radius: 20px
        +m
            aspect-ratio: 1.5/1
            height: auto
            border-radius: 0px
            position: absolute
            top: 0
            width: calc( 100% + $external_margin * 2 )

.gamesGrid
    margin-bottom: 25px
    max-width: 1070px
    margin: 0 auto

.trending
    margin: 0 auto
    margin-top: 40px
    +body-2
    font-weight: 400
    letter-spacing: 2px
    max-width: 1070px
    +m
        font-size: 14px
        margin-left: 20px
.trendingTitle
    +body-2
    margin: 0 auto
    max-width: 1070px
    font-weight: 600
    letter-spacing: 1px
    margin-bottom: calc($external_margin + 10px)
    font-size: 40px
    +m
        font-size: 30px
        margin-left: 20px
